import type { CSSProperties } from 'react';

/** A grey placeholder in the shape of what is loading. Never a blank page. */
export const Skeleton = ({ className = '', style }: { className?: string; style?: CSSProperties }) => (
  <div className={`skeleton ${className}`} style={style} aria-hidden />
);

/** The generic page skeleton: a title, a row of tiles, and a table. */
export function PageSkeleton({ label }: { label?: string }) {
  return (
    <div className="page-skeleton" role="status" aria-live="polite">
      <span className="sr-only">{label ?? 'Loading…'}</span>
      <Skeleton style={{ height: 12, width: 120 }} />
      <Skeleton style={{ height: 28, width: 280, marginTop: 10 }} />
      <Skeleton style={{ height: 14, width: '55%', marginTop: 12 }} />
      <div className="grid grid-4" style={{ marginTop: 24 }}>
        {Array.from({ length: 4 }, (_, i) => (
          <Skeleton key={i} style={{ height: 96, borderRadius: 'var(--radius)' }} />
        ))}
      </div>
      <div className="card" style={{ marginTop: 18, padding: 8 }}>
        {Array.from({ length: 6 }, (_, i) => (
          <Skeleton key={i} style={{ height: 36, margin: 8 }} />
        ))}
      </div>
    </div>
  );
}
